module.exports = __webpack_public_path__ + "img/PPE.577c7758.png";